import { render, staticRenderFns } from "./product-autocomplete.vue?vue&type=template&id=fc560db6&"
import script from "./product-autocomplete.vue?vue&type=script&lang=js&"
export * from "./product-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports